module.exports = __webpack_public_path__ + "static/assets/6d881ffb5edab0e40217a1892a0b4a7e.png";